import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { UPCOMING_INVOICE_ENDPOINT } from './endpoints';

const actions = createActions({
  PAYMENT: {
    GET_BUSINESS_UPCOMING_INVOICE: (businessId) => ({ businessId }),
    API: {
      GET_BUSINESS_UPCOMING_INVOICE: apiResourceActionCreator('upcomingInvoice'),
    },
  },
});

export const apiAction = (authToken, businessId) => commonApiActions.authenticated.get(`${UPCOMING_INVOICE_ENDPOINT}/${businessId}`, authToken, actions.payment.api.getBusinessUpcomingInvoice);

export function* fetchUpcomingInvoice(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.businessId));
};

const configuration = {
  name: 'getBusinessUpcomingInvoice',
  action: actions,
  sagas: fetchUpcomingInvoice,
  reducers: {
    request: (state, _) => ({
      ...state,
      isFetching: true,
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false,
      upcomingInvoice: action.payload.upcomingInvoice,
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false,
      error: action.payload.error,
    }),
  },
};

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/payment/configurations/getBusinessUpcomingInvoice.js